import { useStore } from 'vuex';
import { computed, ref } from 'vue';

export const useConfigLandingPage = () => {
    const store = useStore();
    const NOME_MODULO_VUEX = 'landingPage';

    const criarCampoComputado = (chave) => {
        return computed({
            get: () => {
                const valor = store.getters[`${NOME_MODULO_VUEX}/obterCampoMetadadoPorChave`](chave);
                return valor ?? '';
            },
            set: (valor) => {
                store.dispatch(`${NOME_MODULO_VUEX}/atualizarMetadadosPorChave`, { chave, valor });
            },
        });
    };

    const tituloLandingPage = criarCampoComputado('titulo');
    const descricao = criarCampoComputado('descricao');
    const palavrasChave = criarCampoComputado('palavrasChave');
    const imagemCompartilhamento = criarCampoComputado('imgCompartilhamento');

    const touchedFields = ref({
        tituloLandingPage: false,
        descricao: false,
        palavrasChave: false,
        imagemCompartilhamento: false,
    });

    const isValidUrl = (string) => {
        if (!string) return true;
        try {
            new URL(string);
            return true;
        } catch (_) {
            return false;
        }
    };

    const validationConfig = {
        tituloLandingPage: {
            rules: [(value) => value.trim().length > 0, (value) => value.length <= 60],
            messages: ['Título é obrigatório', 'Máximo 60 caracteres'],
        },
        descricao: {
            rules: [(value) => value.length <= 160],
            messages: ['Recomendação excedida (máximo 160 caracteres)'],
        },
        palavrasChave: {
            rules: [(value) => !value || /^[a-zA-ZÀ-ÿ0-9,\s]*$/.test(value)],
            messages: ['Use apenas letras, números e vírgulas'],
        },
        imagemCompartilhamento: {
            rules: [(value) => !value || isValidUrl(value)],
            messages: ['URL inválida. Use formato: https://exemplo.com/imagem.jpg'],
        },
    };

    const validation = computed(() => {
        const result = {};
        const fields = { tituloLandingPage, descricao, palavrasChave, imagemCompartilhamento };

        Object.keys(validationConfig).forEach((field) => {
            const config = validationConfig[field];
            const value = fields[field].value;

            const failedRuleIndex = config.rules.findIndex((rule) => !rule(value));
            result[field] = {
                isValid: failedRuleIndex === -1,
                message: failedRuleIndex === -1 ? '' : config.messages[failedRuleIndex],
            };
        });
        return result;
    });

    const markFieldAsTouched = (fieldName) => {
        touchedFields.value[fieldName] = true;
    };

    const shouldShowValidationError = (fieldName) => {
        return touchedFields.value[fieldName] && !validation.value[fieldName]?.isValid;
    };

    const getInputClasses = (fieldName) => {
        return [
            'w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 transition-colors',
            shouldShowValidationError(fieldName)
                ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
                : 'border-gray-300 focus:ring-blue-500 focus:border-blue-500',
        ];
    };

    const getTextareaClasses = (fieldName) => {
        return [getInputClasses(fieldName), 'resize-none', shouldShowValidationError(fieldName) ? 'border-orange-400 focus:ring-orange-400' : ''];
    };

    return {
        tituloLandingPage,
        descricao,
        palavrasChave,
        imagemCompartilhamento,
        validation,
        markFieldAsTouched,
        shouldShowValidationError,
        getInputClasses,
        getTextareaClasses,
    };
};
